import { FC } from 'react';

import Auth from './containers/common/Auth';
import BuildConfigLoader from './containers/common/BuildConfigLoader';
import MainContainer from './containers/common/MainContainer';
import MainSettingsLoader from './containers/common/MainSettingsLoader';
import RendererRoutes from './RendererRoutes';

const Routes: FC = () => {
  return (
    <BuildConfigLoader>
      <Auth>
        <MainSettingsLoader>
          <MainContainer>
            <RendererRoutes />
          </MainContainer>
        </MainSettingsLoader>
      </Auth>
    </BuildConfigLoader>
  );
};

export default Routes;
